import { Blockquote } from '@tiptap/extension-blockquote';
import { BulletList } from '@tiptap/extension-bullet-list';
import Heading from '@tiptap/extension-heading';
import Link from '@tiptap/extension-link';
import { OrderedList } from '@tiptap/extension-ordered-list';
import Placeholder from '@tiptap/extension-placeholder';
import { Strike } from '@tiptap/extension-strike';
import TextAlign from '@tiptap/extension-text-align';
import { textblockTypeInputRule } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { CustomLinkExtension } from './CustomLinkExtension';

enum KEYBOARD_SHORTCUTS {
  CmdShiftS = `Cmd-Shift-s`, // strikethrough
  CmdAlt1 = `Cmd-Alt-1`, // Regular text
  CmdAlt2 = `Cmd-Alt-2`, // Heading 1
  CmdAlt3 = `Cmd-Alt-3`, // Heading 2
  CmdAlt4 = `Cmd-Alt-4`, // Heading 3
  CmdAlt5 = `Cmd-Alt-5`, // block quote
  CmdAlt7 = `Cmd-Alt-7`, // numbered list
  CmdAlt8 = `Cmd-Alt-8`, // bulleted list
}

const CustomHeading = Heading.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt1]: () =>
        this.editor.chain().focus().setParagraph().run(),
      [KEYBOARD_SHORTCUTS.CmdAlt2]: () =>
        this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
      [KEYBOARD_SHORTCUTS.CmdAlt3]: () =>
        this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
      [KEYBOARD_SHORTCUTS.CmdAlt4]: () =>
        this.editor.chain().focus().toggleHeading({ level: 3 }).run(),
    };
  },
  addInputRules() {
    return this.options.levels.map((level) => {
      return textblockTypeInputRule({
        find: new RegExp(`^(#{${level}})\\s$`),
        type: this.type,
        getAttributes: {
          level,
        },
      });
    });
  },
});

const CustomBlockQuote = Blockquote.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt5]: () =>
        this.editor.chain().focus().toggleBlockquote().run(),
    };
  },
});

const CustomNumberedList = OrderedList.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt7]: () =>
        this.editor.chain().focus().toggleOrderedList().run(),
    };
  },
});

const CustomBulletList = BulletList.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt8]: () =>
        this.editor.chain().focus().toggleBulletList().run(),
    };
  },
});

const CustomStrike = Strike.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdShiftS]: () =>
        this.editor.chain().focus().toggleStrike().run(),
    };
  },
});

export const richTextEditorExtensions = [
  StarterKit.configure({
    blockquote: false,
    bulletList: false,
    heading: false,
    horizontalRule: false,
    orderedList: false,
    strike: false,
    // ignore for drag and drop
    dropcursor: false,
  }),
  Placeholder.configure({
    placeholder: 'Write something…',
  }),
  CustomLinkExtension,
  Link.configure({
    autolink: true,
    openOnClick: false,
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  CustomBulletList,
  CustomHeading.configure({
    levels: [1, 2, 3],
  }),
  CustomNumberedList,
  CustomBlockQuote,
  CustomStrike,
];
